"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.string = "<ng-container *ngIf=\"!StripeScriptTag.StripeInstance\"><div style=\"color:red;\">Stripe PublishableKey NOT SET. Use method StripeScriptTag.setPublishableKey()</div></ng-container>";
//# sourceMappingURL=stripe-card.pug.js.map